import { toast } from 'react-toastify';

export const copyToClipboard = (link?: string) => {
  navigator.clipboard
    .writeText(link || '')
    .then(() => toast.success('Link copied'))
    .catch((error) => toast.error(error));
};
